import { useEffect, useState } from 'react';
import { Form } from 'rsuite';
import { RsInput } from 'components/Rsuite/Input';
import { RsButton } from 'components/Rsuite/Button';
import { Uploader } from 'rsuite';
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
import { FileType } from 'rsuite/esm/Uploader';
import { useFormik } from 'formik';
import i18n from 'i18n';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import useCreativeStore from 'store/creativeStore';
import { useCampaignStore } from 'store/campaignStore';
import { useProductStore } from 'store/productStore';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import {
  faExternalLinkAlt,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import useImageFormValidation from '../Hooks/useImageFormValidation';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { useCoreContext } from 'contexts/coreContext';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { useOrderStore } from 'store/orderStore';
import useCreativeForm from '../Hooks/useCreativeForm';
import { L1ObjectChannel } from 'core/l1Object/L1Object';
import {
  AWSS3Manager,
  CloudStorageManager,
} from 'core/cloudStorage/CloudStorageManager';
import {
  CreativeManager,
  DefaultCreativeManager,
} from 'core/creative/CreativeManager';
import {
  BindingManager,
  DefaultBindingManager,
} from 'core/binding/BindingManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const cloudStorageManager: CloudStorageManager = new AWSS3Manager();
const creativeManager: CreativeManager = new DefaultCreativeManager();
const bindingManager: BindingManager = new DefaultBindingManager();

const ImageForm = ({ campaignId }) => {
  // const [bannerUrl, setBannerUrl] = useState<string>('');
  const core = useCoreContext();
  const rawAgencyId = _.get(core, 'accountManager.localeMeta.agencyId');
  const agencyId: string | undefined =
    rawAgencyId !== undefined ? String(rawAgencyId) : undefined;

  const { actionType, creative, openCreativeManager, handleChangeCreative } =
    useCreativeStore();
  const { selectedProducts, changeSelectedProducts, resetProductStore } =
    useProductStore();
  // openProductManager => 打開選擇主打品
  const { openProductManager, handleLoading } = useCampaignStore();
  const { getCreativesByCampaignId, getCreative } = useCreativeForm();
  const { order } = useOrderStore();
  // 圖檔
  const [imgFile, setImgFile] = useState<FileType[]>([]);
  const [showLinkList, setShowLinkList] = useState(false);
  // 新增素材後端回傳的素材資料，後續要綁定活動需要素材ID
  const [newCreative, setNewCreative] = useState<any>();
  // 根據actionType來定義初始值
  const initialValues =
    actionType === 'edit'
      ? {
          ...creative,
          typeProperties: {
            width: creative?.creativeValues?.w || 0,
            height: creative?.creativeValues?.h || 0,
          },
          updateImg: false,
        }
      : {
          name: '',
          bannerImageUrl: undefined,
          localImg: imgFile,
          fileSize: undefined,
          fileType: undefined,
          typeProperties: {
            width: undefined,
            height: undefined,
            imageUrl: '',
            product: {},
          },
        };
  // 初始化formik
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {
      handleLoading(true);
      switch (actionType) {
        case 'create':
          handleUploadUrl();
          break;
        case 'edit':
          if (formik.values.updateImg) {
            handleUploadUrl();
          } else {
            handleUpdateCreative(formik.values.bannerImageUrl);
          }
          break;
        default:
          handleUploadUrl();
          break;
      }
    },
  });
  // 引入驗證
  const { errors, handleValidation } = useImageFormValidation({
    defaultForm: creative,
    values: formik.values,
  });
  // 上傳圖片到S3
  const handleUploadUrl = async () => {
    try {
      if (imgFile && imgFile[0]?.blobFile) {
        const imageUrl = await cloudStorageManager.uploadFileToCloud(
          imgFile[0].blobFile,
        );

        if (imageUrl) {
          formik.setFieldValue('bannerImageUrl', imageUrl);
          if (actionType === 'edit') {
            handleUpdateCreative(imageUrl);
          } else {
            handleCreateCreative(imageUrl);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  // 綁定素材
  const handleBindCreative = async () => {
    try {
      const bind = await bindingManager.createBinding(L1ObjectChannel.RTB, [
        {
          l2ChannelIds: [campaignId],
          active: true,
          creativeIds: [newCreative[0].creative.creativeId.toString()],
        },
      ]);
      console.log('bind', bind);
      toast.success('素材建立成功');
      getCreativesByCampaignId(campaignId);
      openCreativeManager(false);
    } catch (error) {
      console.error(error);
    } finally {
      handleLoading(false);
    }
  };
  // 創建素材
  const handleCreateCreative = async (imageUrl) => {
    try {
      const creativeJson = [
        {
          creative: {
            name: formik.values.name,
            creativeType: 1,
            bannerUrl: formik.values.bannerUrl,
            advertiserId: order.advertiserId,
            tenmaxCategory: 'e_commerce',
            typeProperties: {
              width: formik.values?.typeProperties.width.toString(),
              height: formik.values?.typeProperties.height.toString(),
              imageUrl: imageUrl,
              productId: formik.values.typeProperties.product?.productId,
              productName: formik.values.typeProperties.product?.name,
              // product: JSON.stringify(formik.values.typeProperties.product),
            },
          },
        },
      ];

      // return
      const data = await creativeManager.createCreativesByJson(creativeJson);
      if (data) {
        setNewCreative(data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  // 更新素材
  const handleUpdateCreative = async (imageUrl) => {
    try {
      const updateCrative = {
        ...formik.values,
        tenmaxCategory: 'e_commerce',
        typeProperties: {
          width: formik.values?.typeProperties.width.toString(),
          height: formik.values?.typeProperties.height.toString(),
          imageUrl: imageUrl,
          product: selectedProducts[0],
        },
      };
      // return
      const formData = new FormData();
      if (agencyId) {
        formData.append('creative.agencyId', agencyId as string);
      } else {
        throw new Error('agencyId is undefined');
      }

      formData.append('creative.creativeType', updateCrative.creativeType);
      formData.append('creative.name', updateCrative.name);
      formData.append('creative.tenmaxCategory', 'e_commerce');
      formData.append('creative.bannerExtra', updateCrative.bannerExtra);
      formData.append('creative.bannerImageUrl', updateCrative.bannerImageUrl);
      formData.append('creative.bannerUrl', updateCrative.bannerUrl);
      formData.append('creative.retail', updateCrative.retail);
      formData.append('creative.id', creative.creativeId);
      formData.append('creative.advertiserId', order.advertiserId.toString());
      formData.append(
        'creative.typeProperties[height]',
        updateCrative.typeProperties.height,
      );
      formData.append(
        'creative.typeProperties[imageUrl]',
        updateCrative.typeProperties.imageUrl,
      );
      formData.append(
        'creative.typeProperties[productId]',
        updateCrative.typeProperties.product.productId,
      );
      formData.append(
        'creative.typeProperties[productName]',
        updateCrative.typeProperties.product.name,
      );
      formData.append(
        'creative.typeProperties[width]',
        updateCrative.typeProperties.width,
      );

      const data = await creativeManager.updateCreative(formData);
      if (data) {
        toast.success('素材更新成功');
        getCreativesByCampaignId(campaignId);
        openCreativeManager(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      handleLoading(false);
    }
  };
  // 取得圖片尺寸
  const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        const img = new Image();

        img.onload = function () {
          resolve({ width: img.width, height: img.height, type: file.type });
        };

        img.onerror = function () {
          reject(new Error('無法載入圖片'));
        };

        if (event.target && typeof event.target.result === 'string') {
          img.src = event.target.result;
        }
      };

      reader.onerror = function () {
        reject(new Error('無法讀取檔案'));
      };

      reader.readAsDataURL(file);
    });
  };
  // 取得檔案大小
  const getFileSizeMB = (file) => {
    const fileSizeInBytes = file.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    return fileSizeInMB.toFixed(2);
  };
  // 檢查上傳圖片
  const handleCheckUploadImg = async () => {
    try {
      if (imgFile && imgFile[0]?.blobFile) {
        const imageUrl = await getImageDimensions(imgFile[0].blobFile);
        const { width, height, type } = imageUrl as {
          width: string;
          height: string;
          type: string;
        };
        const fileSizeMB = getFileSizeMB(imgFile[0]?.blobFile);
        formik.setFieldValue('typeProperties.width', width);
        formik.setFieldValue('typeProperties.height', height);
        formik.setFieldValue('fileSize', Number(fileSizeMB));
        formik.setFieldValue('fileType', type);
        formik.setFieldValue('updateImg', true);
      }
      if (imgFile && imgFile[0]?.url) {
        const img = new Image();
        img.src = imgFile[0].url;
        img.onload = function () {
          formik.setFieldValue('typeProperties.width', img.width);
          formik.setFieldValue('typeProperties.height', img.height);
        };
      }
    } catch (error) {}
  };

  // 編輯狀態需要重新取得 creative 資料
  useEffect(() => {
    if (actionType === 'edit' && creative) {
      getCreative(creative.id);
    }
  }, []);
  // 編輯狀態將creative圖片資料放入imgFile
  useEffect(() => {
    if (actionType === 'edit' && creative) {
      setImgFile([
        {
          name: creative.bannerImageUrl,
          url: creative.bannerImageUrl,
          fileKey: 1,
        },
      ]);

      formik.setValues(creative);
      changeSelectedProducts(() => [creative.product]);
    }
  }, [creative]);

  useEffect(() => {
    formik.setFieldValue('typeProperties.product', selectedProducts[0]);
  }, [selectedProducts]);

  // 新增素材後綁定活動
  useEffect(() => {
    if (newCreative) {
      handleBindCreative();
    }
  }, [newCreative]);
  // 監聽圖片檔案自動驗證
  useEffect(() => {
    handleCheckUploadImg();
  }, [imgFile]);
  // 監聽formik值變動自動驗證
  useEffect(() => {
    handleValidation();
  }, [formik.values]);

  // component 卸載時
  // 1. 要清空正在編輯的 creative
  // 2. 清空 主打品(product), 因為其他素材類型也有 product
  useEffect(() => {
    return () => {
      formik.resetForm();
      resetProductStore();
      handleChangeCreative(null);
    };
  }, []);

  return (
    <>
      <Form.Group controlId='name'>
        <Form.ControlLabel>素材名稱</Form.ControlLabel>
        <div className={'rs-form-control-wrapper'}>
          <RsInput
            className='!w-[420px]'
            value={formik.values.name}
            onChange={(value) => {
              formik.setFieldValue('name', value);
            }}
            errorMessage={errors?.name as string}
          />
        </div>
      </Form.Group>
      <Form.Group controlId='bannerUrl'>
        <Form.ControlLabel>素材網址</Form.ControlLabel>
        <div className={'rs-form-control-wrapper'}>
          <div className='flex flex-col items-start gap-2'>
            <div className='flex items-center gap-2'>
              <RsInput
                value={formik.values?.bannerUrl}
                className='!w-[420px]'
                onChange={(value) => {
                  const trimValue = value.replace(/\s/g, '');
                  formik.setFieldValue('bannerUrl', trimValue);
                }}
                errorMessage={errors?.bannerUrl as string}
              />
              <IconWithTooltip
                icon={faExternalLinkAlt}
                onClick={() => {
                  // 如果 '素材網址' 驗證沒過, 就不要往下走
                  if (errors?.bannerUrl) return;
                  window.open(formik.values.bannerUrl, '_blank', 'noopener');
                }}
                tooltipProps={{
                  id: `creativeFormAdLinkBtn`,
                  tooltip: i18n.t<string>(
                    'creativeSetupFlow.labels.openLinkHint',
                  ),
                }}
                className='!text-[#615f67]'
              />
            </div>
            <div
              onClick={() => setShowLinkList((prev) => !prev)}
              className='cursor-pointer'
            >
              <Form.HelpText className='ml-0'>
                <FontAwesomeIcon icon={faInfoCircle} className='mr-1' />
                展開查看 mo 店+ 開放可輸入連結
                <span className='inline-bloock ml-1'>
                  <ArrowDownLineIcon
                    style={{
                      transform: showLinkList ? 'rotate(180deg)' : 'none',
                    }}
                  />
                </span>
              </Form.HelpText>
            </div>
            <div
              className={`overflow-hidden transition-all duration-500 ${showLinkList ? 'max-h-96' : 'max-h-0'}`}
            >
              <Form.HelpText className='ml-0 max-w-[440px]'>
                <div>
                  <ol className='pl-3 text-[12px]'>
                    <li className='mb-2 text-wrap break-all'>
                      商店首頁
                      (範例：https://www.momoshop.com.tw/TP/XXXXXXXXX/main)
                    </li>
                    <li className='mb-2 text-wrap break-all'>
                      商品列表頁
                      (範例：https://www.momoshop.com.tw/TP/XXXXXXXXX/goods)
                    </li>
                    <li className='mb-2 text-wrap break-all'>
                      分類頁
                      (範例：https://m.momoshop.com.tw/category.momo?cn=XXXXXXXXXXXX&entpCode=XXXXXXXXX)
                    </li>
                    <li className='mb-2 text-wrap break-all'>
                      商品詳情頁
                      (範例：https://www.momoshop.com.tw/TP/XXXXXXXXX/goodsDetail/XXXXXXXXXXXXXXXX)
                    </li>
                  </ol>
                </div>
              </Form.HelpText>
            </div>
          </div>
        </div>
      </Form.Group>
      <Form.Group controlId='imageUrl'>
        <Form.ControlLabel>圖片檔案</Form.ControlLabel>
        <div className='rs-form-control-wrapper'>
          <Uploader
            listType='picture'
            className='!flex flex-col-reverse'
            autoUpload={false}
            multiple={false}
            accept='image/png'
            maxPreviewFileSize={2 * 1024 * 1024}
            fileList={imgFile}
            action=''
            draggable
            onChange={setImgFile}
            disabled={imgFile?.length > 0}
            onRemove={() => {
              formik.setFieldValue('bannerImageUrl', undefined);
              formik.setFieldValue('typeProperties.width', undefined);
              formik.setFieldValue('typeProperties.height', undefined);
            }}
            renderThumbnail={(file) => {
              const src =
                actionType === 'edit' && !formik.values.updateImg
                  ? file.url
                  : file.blobFile
                    ? URL.createObjectURL(file.blobFile)
                    : '';
              return (
                <>
                  <img
                    src={src}
                    alt=''
                    style={{ width: '100%', height: '100%' }}
                  />
                  <div className='flex flex-col gap-1'>
                    {(errors?.typeProperties?.width !== undefined ||
                      errors?.typeProperties?.height !== undefined) && (
                      <span className='inlin-block text-red-500'>{`不支援圖片尺寸${formik.values.typeProperties?.width} x ${formik.values.typeProperties?.height}`}</span>
                    )}
                    {errors?.fileType !== undefined && (
                      <span className='inlink-block text-red-500'>
                        {'檔案格式不符合PNG'}
                      </span>
                    )}
                    {errors?.fileSize !== undefined && (
                      <span className='inlink-block text-red-500'>
                        {'檔案大小須小於 2MB'}
                      </span>
                    )}
                  </div>
                </>
              );
            }}
          >
            {imgFile?.length === 0 ? (
              <div
                style={{
                  width: '420px',
                  height: '200px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border:
                    formik?.errors?.bannerImageUrl !== undefined
                      ? '1px dashed #f44336'
                      : '1px dashed #d9d9d9',
                }}
              >
                <span>拖放檔案或選取</span>
              </div>
            ) : (
              <></>
            )}
          </Uploader>
          <div className='mt-2 flex flex-col gap-1'>
            <span className='inline-block text-[12px] font-medium leading-[1.17] text-[#98969d]'>
              限定 PNG 格式，圖片尺寸須符合 960 x 320 或 1000 x 60
            </span>
            <span className='inline-block text-[12px] font-medium leading-[1.17] text-[#98969d]'>
              檔案大小須小於 2MB
            </span>
          </div>
        </div>
      </Form.Group>
      <Form.Group controlId='name'>
        <Form.ControlLabel>主打品</Form.ControlLabel>
        {selectedProducts.length > 0 && actionType === 'create' && (
          <div className='flex items-start gap-2'>
            <div className='float-left w-[420px] rounded border border-gray-300 px-2 py-3'>
              {selectedProducts.map((product) => (
                <span
                  key={product.productId}
                  className='inline-block break-words border border-[#98969d] bg-[#f7f7f7] p-2 text-[#242328]'
                >
                  {product.name}
                  <WarningRoundIcon
                    className='ml-1 cursor-pointer text-[#413993]'
                    onClick={() => changeSelectedProducts(() => [])}
                  />
                </span>
              ))}
            </div>
            <div>
              <IconWithTooltip
                icon={faPencilAlt}
                tooltipProps={{
                  id: `select-product-field-edit-products-hint`,
                  tooltip: i18n.t<string>(
                    'creativeSetupFlow.labels.editProductsHint',
                  ),
                }}
                onClick={() => openProductManager(true)}
              />
            </div>
          </div>
        )}
        {selectedProducts.length > 0 && actionType !== 'create' && (
          <div className='flex items-start gap-2'>
            <div className='float-left w-[420px] rounded'>
              {selectedProducts?.map((product, index) => (
                <span
                  key={product?.productId || index}
                  className='inline-block break-words'
                >
                  {product?.name || ''}
                </span>
              ))}
            </div>
          </div>
        )}
        {selectedProducts.length === 0 && (
          <RsButton
            appearance='ghost'
            className='!border-[#615f67] !text-[#615f67]'
            onClick={() => openProductManager(true)}
            errorMessage={errors?.typeProperties?.product as string}
          >
            選擇商品
          </RsButton>
        )}
      </Form.Group>

      <div className='pb-4 pt-10'>
        <div className='flex items-center justify-start gap-4'>
          <RsButton
            appearance='primary'
            onClick={() => formik.handleSubmit()}
            disabled={!_.isEmpty(errors)}
          >
            <span className='text-[16px]'>完成</span>
          </RsButton>
        </div>
      </div>
    </>
  );
};

export default ImageForm;
